import React, { useState } from "react";
import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
import ProgressButton from "react-progress-button";
import styles from "../InvoiceDetails/InvoiceDetails.module.css";
import axios from "axios";
import EmailModal from "./EmailModal";
import { API } from "../../api";

pdfMake.vfs = pdfFonts.pdfMake.vfs;

const InvoicePdfGenerator = ({ invoices, name }) => {
  const [downloadStatus, setDownloadStatus] = useState(null);
  const [sendStatus, setSendStatus] = useState(null);
  const [open, setOpen] = useState(false);
  const [reciver, setReciver] = useState({
    name: "",
    email: "",
  });

  // create invoice data

  const uniqueClients = new Set();

  invoices.forEach((invoice) => {
    uniqueClients.add(invoice?.client?.name);
  });
  const data = {
    receiver: reciver.name,
    name: name,
    date: new Date(),
    items: invoices.map((invoice) => ({
      invoiceNumber: invoice.invoiceNumber,
      clientName: invoice?.client?.name,
      products: invoice.items.map((item) => ({
        name: item.itemName,
        qty: item.quantity,
      })),
      amount: invoice.total,
      status: invoice.status,
    })),
    totalReceived: invoices
      .filter((e) => e.status !== "Unpaid")
      .reduce(
        (total, invoice) => total + parseFloat(invoice.totalAmountReceived),
        0
      ),
    TotalPending: (
      invoices.reduce(
        (total, invoice) => total + parseFloat(invoice.total),
        0
      ) -
      invoices
        .filter((e) => e.status !== "Unpaid")
        .reduce(
          (total, invoice) => total + parseFloat(invoice.totalAmountReceived),
          0
        )
    ).toFixed(2),
    clientNumber: uniqueClients.size,
    nbrInvoicePaid: invoices.filter((e) => e.status === "Paid").length,
    nbrInvoiceUnPaid: invoices.filter((e) => e.status === "Unpaid").length,
  };

  const handleSendMail = (e) => {
    e.preventDefault();
    setSendStatus("loading");
    API.post(`/send-pdf-resume`, {
      email: reciver.email,
      data,
    })
      // .then(() => console.log("invoice sent successfully"))
      .then(() => setSendStatus("success"))
      .catch((error) => {
        console.log(error);
        setSendStatus("error");
      });
  };

  const generatePdf = () => {
    setDownloadStatus("loading");
    // Function to create the PDF content for all invoices.
    function createPdfContent(invoices) {
      const tableBody = [];

      // Adding the table header.
      const tableHeader = [
        { text: "Invoice Number", style: "tableHeader" },
        { text: "Client Name", style: "tableHeader" },
        { text: "Products", style: "tableHeader" },
        { text: "Total Amount", style: "tableHeader" },
        { text: "Status", style: "tableHeader" },
      ];

      tableBody.push(tableHeader);

      let totalReceived = 0;

      let totalPrice = 0;
      const clientsSet = new Set();
      let totalInvoices = 0;
      let totalPaidInvoices = 0;
      let totalUnpaidInvoices = 0;
      let totalParcialInvoices = 0;

      // Helper function to find the index of an existing row in the tableBody for the same invoice.
      const findExistingRow = (invoiceNumber) => {
        return tableBody.findIndex(
          (row) => row[0].text === invoiceNumber.toString()
        );
      };

      // Adding the items to the table.
      invoices.forEach((invoice) => {
        const {
          invoiceNumber,
          client,
          items,
          totalAmountReceived,
          total,
          status,
        } = invoice;
        clientsSet.add(client.name);
        totalInvoices++;
        if (status !== "Unpaid") {
          totalReceived += parseFloat(totalAmountReceived);
        }

        totalPrice += parseFloat(total);
        if (status === "Paid") {
          totalPaidInvoices++;
        } else if (status === "Unpaid") {
          totalUnpaidInvoices++;
        } else {
          totalParcialInvoices++;
        }

        const rowIdx = findExistingRow(invoiceNumber);
        if (rowIdx !== -1) {
          // Invoice already exists in the table, update the products and total amount.
          tableBody[rowIdx][2].text +=
            "\n" +
            items.map((item) => `${item.quantity} ${item.itemName}`).join("\n");
          tableBody[rowIdx][3].text = `${
            parseFloat(tableBody[rowIdx][3].text) +
            parseFloat(totalAmountReceived)
          } ${invoice.currency}`;
        } else {
          // Add a new row for the invoice.
          const row = [
            { text: invoiceNumber.toString(), style: "tableCell" },
            { text: client.name, style: "tableCell" },
            {
              text: items
                .map((item) => `${item.quantity} ${item.itemName}`)
                .join("\n"),
              style: "tableCell",
            },
            {
              text: `${total} ${invoice.currency}`,
              style: "tableCell",
            },
            { text: status, style: "tableCell" },
          ];

          tableBody.push(row);
        }
      });

      // Create the PDF content with the table.
      const content = [
        { text: "Invoice Details", style: "header" },
        {
          text: " Invoice report by " + name,
          style: "pdfName",
          margin: [0, 10, 0, 5],
        },
        {
          text: `Date: ${new Date().toLocaleDateString()}`,
          style: "pdfDate",
          margin: [0, 0, 0, 20],
        },

        {
          table: {
            headerRows: 1,
            widths: ["auto", "*", "*", "auto", "auto"],
            body: tableBody,
          },
          layout: "lightHorizontalLines",
        },
        { text: "Summary", style: "summaryHeader" },
        {
          table: {
            headerRows: 0,
            widths: ["auto", "auto", "auto", "auto", "auto"],
            body: [
              [
                "Total :",
                { text: `${totalPrice.toFixed(2)} TND`, alignment: "right" },
                "",
                "",
                "",
              ],
              [
                "Total Received:",
                { text: `${totalReceived.toFixed(2)} TND`, alignment: "right" },
                "",
                "",
                "",
              ],
              [
                "Total Pending:",
                {
                  text: `${(totalPrice - totalReceived).toFixed(2)} TND`,
                  alignment: "right",
                },
                "",
                "",
                "",
              ],
              [
                "Total Number of Clients:",
                { text: `${clientsSet.size}`, alignment: "right" },
                "",
                "",
                "",
              ],
              [
                "Total Number of Invoices:",
                { text: `${totalInvoices}`, alignment: "right" },
                "",
                "",
                "",
              ],
              [
                "Total Number of Paid Invoices:",
                { text: `${totalPaidInvoices}`, alignment: "right" },
                "",
                "",
                "",
              ],
              [
                "Total Number of Unpaid Invoices:",
                { text: `${totalUnpaidInvoices}`, alignment: "right" },
                "",
                "",
                "",
              ],
              [
                "Total Number of Parcial Invoices:",
                { text: `${totalParcialInvoices}`, alignment: "right" },
                "",
                "",
                "",
              ],
            ],
          },
          layout: "noBorders",
        },
      ];

      return content;
    }

    // Create the PDF document definition.
    const documentDefinition = {
      content: createPdfContent(invoices),
      styles: {
        header: {
          fontSize: 18,
          bold: true,
          margin: [0, 0, 0, 10],
        },
        tableHeader: {
          bold: true,
          fillColor: "#f2f2f2",
        },
        tableCell: {
          margin: [0, 5],
        },
        totalLabel: {
          fontSize: 14,
          bold: true,
          margin: [0, 10, 0, 0],
          alignment: "right",
        },
        totalValue: {
          fontSize: 14,
          bold: true,
          margin: [0, 0, 0, 10],
          alignment: "right",
        },
        summaryHeader: {
          fontSize: 16,
          bold: true,
          margin: [0, 20, 0, 5],
        },
        pdfName: {
          fontSize: 18,
          bold: true,
          alignment: "center",
        },
        pdfDate: {
          fontSize: 14,
          alignment: "center",
        },
      },
    };

    // Generate and open the PDF in a new window.
    pdfMake.createPdf(documentDefinition).open();
    setDownloadStatus("success");
  };

  return (
    <div className={styles.buttons}>
      <ProgressButton onClick={generatePdf} state={downloadStatus}>
        Download PDF
      </ProgressButton>
      <ProgressButton onClick={() => setOpen(true)} state={sendStatus}>
        Send via email
      </ProgressButton>
      <EmailModal
        open={open}
        setOpen={setOpen}
        handleSendMail={handleSendMail}
        reciver={reciver}
        setReciver={setReciver}
      />
    </div>
  );
};

export default InvoicePdfGenerator;
